import { cn } from '@/lib/cn';

type SiteItem = { id: number; site_name: string };

type Props = {
  sites: SiteItem[];
  currentSiteId: number;
  allSitesMode: boolean;
  onSwitch: (siteId: number) => void;
};

export function SiteMasterSiteSwitcher({ sites, currentSiteId, allSitesMode, onSwitch }: Props) {
  const value = allSitesMode ? '0' : String(currentSiteId);

  return (
    <div className="relative shrink-0">
      <select
        value={value}
        onChange={(e) => onSwitch(Number(e.target.value))}
        aria-label="选择站点"
        className={cn(
          'max-w-[9.5rem] appearance-none rounded-xl border-2 border-slate-200',
          'bg-white py-2 pl-3 pr-8 text-base font-semibold text-slate-800',
          'truncate focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500/20',
        )}
      >
        <option value="0">全部</option>
        {sites.map((s) => (
          <option key={s.id} value={String(s.id)}>
            {s.site_name}
          </option>
        ))}
      </select>
      <i
        className="fa-solid fa-chevron-down pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400"
        aria-hidden
      />
    </div>
  );
}
